var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.641,
    height: 16.642,
    viewBox: "0 0 16.641 16.642",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(0.237 0.238)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.371,
    cy: 5.371,
    r: 5.371,
    transform: "translate(0.549 4.75) rotate(-23.025)",
    fill: "none",
    stroke: "#1c75bb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0,4.165,4.166",
    transform: "translate(11.39 11.39)",
    fill: "none",
    stroke: "#1c75bb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7a6eeb39100e47e3ccc75e807721c7eb.svg";
export { ForwardRef as ReactComponent };